import axios from '@/utils/axios';
const apiUrl = {
  getFundsFlowDataUrl: '/extractor/tt/agent/funds/effictive',
  getFundsFlowDetailListUrl: '/extractor/tt/agent/funds/flowlist',
};
export function getFundsFlowData(date) {
  return axios.get(apiUrl.getFundsFlowDataUrl, {params:{date}});
}
export function getFundsFlowDetailList(date,port,companyName) {
  return axios.get(apiUrl.getFundsFlowDetailListUrl, {params:{date,port,companyName}});
}
